
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b89942838 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b525138742 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b141459382 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a893677009 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a795727742 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.a1145558132 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a238058070 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b975511851 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail-cím"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a695267940 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b272676349 = messageFormatterFn((function(  ) {
  return function(d) { return "Ez egy nyilvános vagy megosztott eszköz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b789398212 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem a saját eszközödet használod? Ha bejelölöd ezt a négyzetet, akkor kevesebb ideig maradsz bejelentkezve itt."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b584908585 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezve szeretnék maradni"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1415490631 = messageFormatterFn((function(  ) {
  return function(d) { return "Ha bejelölöd ezt a jelölőnégyzetet, addig maradsz bejelentkezve a fiókodba ezen az eszközön, amíg ki nem jelentkezel. Ne jelöld be közösen használt eszközökön."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a236954687 = messageFormatterFn((function(  ) {
  return function(d) { return "Elfelejtetted a jelszót?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1799645072 = messageFormatterFn((function(  ) {
  return function(d) { return "Tovább"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1079347523 = messageFormatterFn((function(  ) {
  return function(d) { return "Mégse"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1763190374 = messageFormatterFn((function(  ) {
  return function(d) { return "Vissza"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1142187368 = messageFormatterFn((function(  ) {
  return function(d) { return "Újratöltés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b299056467 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezéssel elfogadod a(z) " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">Általános Szerződési Feltételeit</a> és <a href=" + d["2"] + " " + d["4"] + ">Adatvédelmi nyilatkozatát</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1277726421 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezéssel elfogadod a(z) " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Általános szerződési feltételeit</a> és <a href=" + d["2"] + " " + d["6"] + ">Adatvédelmi nyilatkozatát</a>, valamint a(z) <a href=" + d["3"] + " " + d["7"] + "> " + d["4"] + "Általános szerződési feltételeit</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1883580131 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezéssel csatlakozol a(z) " + d["4"] + " programhoz is. Továbbá elfogadod a(z) " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Általános szerződési feltételeit</a> és <a href=" + d["2"] + " " + d["6"] + ">Adatvédelmi nyilatkozatát</a>, valamint a(z) <a href=" + d["3"] + " " + d["7"] + "> " + d["4"] + "Általános szerződési feltételeit</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1410210104 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiókodat egy biztonsági rutinellenőrzés során szüneteltettük. Adataid biztonságban vannak, de a jelszavadat meg kell változtatni. A bejelentkezéshez módosítsd az alábbi, „Elfelejtetted a jelszavadat?” linket követve."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1544920782 = messageFormatterFn((function(  ) {
  return function(d) { return "Az e-mail-cím és a jelszó nem egyezik. Próbálkozz később."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1286651287 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt a rendszerünkben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1524600273 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt a rendszerünkben. Próbálkozz egy kicsit később."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b457251763 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az e-mail-címed."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1680028638 = messageFormatterFn((function(  ) {
  return function(d) { return "Érvényes e-mail-címet adj meg."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a952891612 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a jelszavadat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1006057094 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezési adatok ellenőrzése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1355246591 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó elrejtése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1669588730 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó megjelenítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b870268668 = messageFormatterFn((function(  ) {
  return function(d) { return "Még nincs fiókod? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Hozz létre egyet</a></span>"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1916948407 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1573446784 = messageFormatterFn((function(  ) {
  return function(d) { return "A továbbiakban nem fogsz tudni a(z) " + d["0"] + " használatával bejelentkezni"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1976905316 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszavad átállítása után továbbra is hozzáférhetsz " + d["0"] + "-fiókodhoz ugyanazzal az e-mail-címmel. Ez nem érinti " + d["1"] + "-fiókodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a761641106 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszavadat az alábbi gombra kattintva állíthatod át. Legközelebb jelentkezz be közvetlenül a(z) " + d["0"] + " oldalán az e-mail-címeddel és az új jelszavaddal. "; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1722818421 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO-bejelentkezés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b163070317 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés egyszeri bejelentkezés használatával"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a812868545 = messageFormatterFn((function(  ) {
  return function(d) { return "Vagy használd " + d["0"] + "-fiókodat"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1933990412 = messageFormatterFn((function(  ) {
  return function(d) { return "Gyűjts ingyenes utazásra váltható pontokat. Spórolj a tagoknak szóló árakkal. Érd el az útiterveidet könnyedén."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a665306894 = messageFormatterFn((function(  ) {
  return function(d) { return "Szerezz meg " + d["0"] + " Expedia+ Rewards-pontot ezzel az utazással."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1742985579 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés a(z) " + d["0"] + "-fiókba"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2001277459 = messageFormatterFn((function(  ) {
  return function(d) { return "új lapon nyílik meg"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b934915185 = messageFormatterFn((function(  ) {
  return function(d) { return "Általános szerződési feltételeinket (" + d["0"] + ")"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a362853871 = messageFormatterFn((function(  ) {
  return function(d) { return "Adatvédelmi nyilatkozatunkat (" + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b80746188 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key Általános szerződési feltételeit (" + d["0"] + ") "; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a846866025 = messageFormatterFn((function(  ) {
  return function(d) { return "Elfelejtett jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a841810030 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a164278904 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg e-mail-címedet, és elküldjük a jelszó megváltoztatására szolgáló hivatkozást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2128593396 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszómódosítási hivatkozás küldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a710818927 = messageFormatterFn((function(  ) {
  return function(d) { return "Beérkező üzenetek ellenőrzése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b229926633 = messageFormatterFn((function(  ) {
  return function(d) { return "Elküldtük a jelszó módosításához használható hivatkozást tartalmazó e-mailt a címedre (" + d["0"] + ")."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b229925672 = messageFormatterFn((function(  ) {
  return function(d) { return "Az e-mail kézbesítése beletelhet néhány percbe. Ha 10 perc elteltével sem találod, tekintsd meg a levélszemét- vagy spammappát."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2107322942 = messageFormatterFn((function(  ) {
  return function(d) { return "Hivatkozás újraküldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b700700486 = messageFormatterFn((function(  ) {
  return function(d) { return "Új hivatkozást küldtünk neked."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1285716653 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók ellenőrzése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a812128659 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1068057860 = messageFormatterFn((function(  ) {
  return function(d) { return "Örülünk, hogy visszatértél!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1509695010 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz hozz létre egy egyedi jelszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b609985517 = messageFormatterFn((function(  ) {
  return function(d) { return "Sikerült!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a400253066 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostantól használd az új jelszót."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a735689595 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1856070178 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos ennek a kérésnek az időkorlátja lejárt. Ha még mindig szükség van a jelszómódosításra, kattints az alábbi lehetőségre egy új jelszómódosítási e-mail küldéséhez."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a51122 = messageFormatterFn((function(  ) {
  return function(d) { return "Hivatkozás újraküldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a203646045 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó mentése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1753528143 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1321539779 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a82557198 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail-cím"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b802846330 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az e-mail-címedet."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a926558295 = messageFormatterFn((function(  ) {
  return function(d) { return "Érvényes e-mail-címet adj meg."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1588726995 = messageFormatterFn((function(  ) {
  return function(d) { return "Keresztnév"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1581594715 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a keresztneved."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a14938897 = messageFormatterFn((function(  ) {
  return function(d) { return "Vezetéknév"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1647399015 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a vezetékneved."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b223501166 = messageFormatterFn((function(  ) {
  return function(d) { return "A névben csak betűket használj"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a865321355 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b797016557 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a jelszavadat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1763451298 = messageFormatterFn((function(  ) {
  return function(d) { return "Adj meg egy érvényes jelszót."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b518220066 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszó 9–64 karakterből állhat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b518219105 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszónak betűket és számokat is tartalmaznia kell."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b518218144 = messageFormatterFn((function(  ) {
  return function(d) { return "Egy különleges karaktert: ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b518217183 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszóban nem szerepelhet szóköz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1571408344 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszónak 8–64 karakteresnek kell lennie."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b751475707 = messageFormatterFn((function(  ) {
  return function(d) { return "Az e-mail-címedet nem használhatod jelszóként."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a742364290 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszóban nem szerepelhet szóköz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1432623558 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiók létrehozásával elfogadod a(z) " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">Általános Szerződési Feltételeit</a> és <a href=" + d["2"] + " " + d["4"] + ">Adatvédelmi nyilatkozatát</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a902977640 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiók létrehozásával elfogadod a(z) " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Általános szerződési feltételeit</a> és <a href=" + d["2"] + " " + d["6"] + ">Adatvédelmi nyilatkozatát</a>, valamint a(z) <a href=" + d["3"] + " " + d["7"] + "> " + d["4"] + "Általános szerződési feltételeit</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b71881335 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretnék a(z) " + d["0"] + " által kínált utazási akciókat, különleges ajánlatokat és egyéb információkat kapni e-mailben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1002013818 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretnék a(z) " + d["0"] + " által kínált utazási akciókat, különleges ajánlatokat és egyéb információkat kapni e-mailben. A promóciós e-mailekről bármikor leiratkozhatsz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1346321524 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretnék a(z) " + d["0"] + " által kínált üdülési ötleteket, különleges ajánlatokat és egyéb információkat kapni e-mailben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1083834979 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretnék a(z) " + d["0"] + " által kínált üdülési ötleteket, különleges ajánlatokat és egyéb információkat kapni e-mailben. A promóciós e-mailekről bármikor leiratkozhatsz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1629591657 = messageFormatterFn((function(  ) {
  return function(d) { return "Tovább"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1015010012 = messageFormatterFn((function(  ) {
  return function(d) { return "Már van fiókod? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Bejelentkezés</a></span>"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b409028447 = messageFormatterFn((function(  ) {
  return function(d) { return "Üdv, " + d["0"] + "!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1127688197 = messageFormatterFn((function(  ) {
  return function(d) { return "Új " + d["0"] + "-fiókoddal a világ csak egy karnyújtásnyira van."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a637692174 = messageFormatterFn((function(  ) {
  return function(d) { return "Tovább"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a148714499 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz erősebb jelszót kell megadni"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1360106552 = messageFormatterFn((function(  ) {
  return function(d) { return "Legalább 8 karakterből kell állnia."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b544285972 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszó erőssége"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a301030870 = messageFormatterFn((function(  ) {
  return function(d) { return "Gyenge"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b228098955 = messageFormatterFn((function(  ) {
  return function(d) { return "Erős"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1380241845 = messageFormatterFn((function(  ) {
  return function(d) { return "Nagyon erős"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a527236474 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld a könnyen kitalálható betűhelyettesítő karaktereket, például ne használd a „@” jelet az „a” betű helyett."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b695506078 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld a gyakori szavak visszafelé írt változatait."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a343777878 = messageFormatterFn((function(  ) {
  return function(d) { return "Használj nagybetűket, de nem legyen minden betű nagy."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a172151927 = messageFormatterFn((function(  ) {
  return function(d) { return "Ne csak az első betű legyen nagybetű."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a548347781 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld a hozzád társítható dátumokat és évszámokat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2079267333 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld az elmúlt néhány év évszámát."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2103412886 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld a hozzád társítható évszámokat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a531880983 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld a gyakoran előforduló karakterláncokat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1883491889 = messageFormatterFn((function(  ) {
  return function(d) { return "Kerüld az ismétlődő szavakat és karaktereket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b171778859 = messageFormatterFn((function(  ) {
  return function(d) { return "Használj hosszabb billentyűzetmintákat, és közben válts többször irányt."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a117337530 = messageFormatterFn((function(  ) {
  return function(d) { return "Használj több ritka szót."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1961472678 = messageFormatterFn((function(  ) {
  return function(d) { return "Használj több szót, de kerüld a gyakori kifejezéseket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b731167863 = messageFormatterFn((function(  ) {
  return function(d) { return "Szimbólumok, számjegyek és nagybetűk nélkül is létrehozhatsz erős jelszót."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b102922160 = messageFormatterFn((function(  ) {
  return function(d) { return "Ez az e-mail-cím már hozzá van rendelve egy " + d["0"] + "-fiókhoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b181704450 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailben elküldtük a fiók létrehozásának befejezéséhez használható linket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b868214227 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiók létrehozása folyamatban van"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a467082521 = messageFormatterFn((function(  ) {
  return function(d) { return "A keresztnévnek legalább két betűből kell állnia"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1796409013 = messageFormatterFn((function(  ) {
  return function(d) { return "A vezetéknévnek legalább két betűből kell állnia"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1715132359 = messageFormatterFn((function(  ) {
  return function(d) { return "A keresztnév legfeljebb 100 betűs lehet."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1250508445 = messageFormatterFn((function(  ) {
  return function(d) { return "A vezetéknév legfeljebb 100 betűs lehet."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b603535102 = messageFormatterFn((function(  ) {
  return function(d) { return "A keresztnév nem tartalmazhat speciális karaktert"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1273936798 = messageFormatterFn((function(  ) {
  return function(d) { return "A vezetéknév nem tartalmazhat speciális karaktert"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1120343072 = messageFormatterFn((function(  ) {
  return function(d) { return "Elfogadom az alábbiak mindegyikét"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1825123052 = messageFormatterFn((function(  ) {
  return function(d) { return "Megerősítem, hogy betöltöttem a 18. életévemet, továbbá elolvastam és elfogadom a <a href=" + d["0"] + " " + d["1"] + ">Felhasználási feltételek</a> és az <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + "Általános szerződési feltételek</a> tartalmát. (Kötelező)*"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1525786154 = messageFormatterFn((function(  ) {
  return function(d) { return "Beleegyezem a személyes adataim <a href=" + d["0"] + " " + d["1"] + ">Adatvédelmi nyilatkozatban</a> leírtaknak megfelelő gyűjtésébe és felhasználásába. (Kötelező)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b955785673 = messageFormatterFn((function(  ) {
  return function(d) { return "Beleegyezem abba, hogy a személyes adataimat hozzáférhetővé tegyék harmadik felek számára Koreában vagy külföldön, az <a href=" + d["0"] + " " + d["1"] + ">Adatvédelmi nyilatkozatban</a> leírtaknak megfelelően. (Kötelező)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1758841332 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz fogadd el a feltételeket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b331216016 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz fogadd el a feltételeket"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1275888492 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelöld be a négyzetet a folytatáshoz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b846410651 = messageFormatterFn((function(  ) {
  return function(d) { return "Vagy regisztrálj fiókot a(z) " + d["0"] + " rendszerében"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1514409529 = messageFormatterFn((function(  ) {
  return function(d) { return "A jelszóban kerüld a szóköz használatát, illetve ügyelj rá, hogy ne tartalmazza a nevedet, az e-mail-címedet vagy a korábban használt jelszavaidat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b763311037 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos hiba történt a rendszerünkben. Várj néhány percet, majd próbálkozz újra."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2107707113 = messageFormatterFn((function(  ) {
  return function(d) { return "Mobilszám ellenőrzése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b346304614 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiókod védelme érdekében küldeni fogunk egy egyszer használatos megerősítő kódot a mobilszámodra."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1793635699 = messageFormatterFn((function(  ) {
  return function(d) { return "Küldés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1637978278 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Minden jog fenntartva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1177606824 = messageFormatterFn((function(  ) {
  return function(d) { return "Általános szerződési feltételek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1524222231 = messageFormatterFn((function(  ) {
  return function(d) { return "Adatvédelmi irányelvek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a273758336 = messageFormatterFn((function(  ) {
  return function(d) { return "SMS-t kérek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1201883029 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a megerősítő kódot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a183547207 = messageFormatterFn((function(  ) {
  return function(d) { return "Megerősítő kód"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b18344134 = messageFormatterFn((function(  ) {
  return function(d) { return "Kód újraküldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1145756817 = messageFormatterFn((function(  ) {
  return function(d) { return "Mobilszám módosítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1266261181 = messageFormatterFn((function(  ) {
  return function(d) { return "A megerősítő kódot ismét elküldtük."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1425871900 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a következő számra küldött hatjegyű megerősítő kódot: " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a223751913 = messageFormatterFn((function(  ) {
  return function(d) { return "Megerősítő kód ellenőrzése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1242864190 = messageFormatterFn((function(  ) {
  return function(d) { return "Ez a kód helytelen. Az újrapróbálkozáshoz kérj új kódot."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1959920584 = messageFormatterFn((function(  ) {
  return function(d) { return "vagy jelentkezz be az alábbiak egyikével:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1203708376 = messageFormatterFn((function(  ) {
  return function(d) { return "Tagként átlagosan " + d["0"] + "%-ot spórolhatsz hotelek ezrein – a tagság mindig ingyenes."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b522794650 = messageFormatterFn((function(  ) {
  return function(d) { return "vagy"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1789633308 = messageFormatterFn((function(  ) {
  return function(d) { return "Más bejelentkezési módszerek"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1789273894 = messageFormatterFn((function(  ) {
  return function(d) { return "Más módszerek a regisztrációra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1829958736 = messageFormatterFn((function(  ) {
  return function(d) { return "Regisztráció Google-fiókkal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a959519631 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezés sikertelen volt. Próbálkozz újra, vagy hozz létre egy fiókot ezen az oldalon a folytatáshoz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b313671159 = messageFormatterFn((function(  ) {
  return function(d) { return "Telefonszámmal nem lehet bejelentkezni. Állítsd be közösségi fiókodat úgy, hogy megossza az e-mail-címedet."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a344856833 = messageFormatterFn((function(  ) {
  return function(d) { return "Tagként " + d["0"] + "%-ot vagy még többet spórolhatsz hotelek ezrein – a tagság mindig ingyenes."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a131262438 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés Google-fiókkal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1666175515 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés NAVER használatával"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1630946939 = messageFormatterFn((function(  ) {
  return function(d) { return "Túllépted a bejelentkezési kísérletek maximális számát. Kérjük, próbálkozz később!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a623134296 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés biometrikus azonosítóval"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1936785096 = messageFormatterFn((function(  ) {
  return function(d) { return "Használj biometrikus azonosítást a fiókod eléréséhez, hogy ne kelljen beírnod a jelszavadat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a701753909 = messageFormatterFn((function(  ) {
  return function(d) { return "Kezdés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a823971035 = messageFormatterFn((function(  ) {
  return function(d) { return "Emlékeztessen később"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a287073231 = messageFormatterFn((function(  ) {
  return function(d) { return "Sikerült!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b187949109 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekapcsoltuk a biometrikus azonosítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1245387597 = messageFormatterFn((function(  ) {
  return function(d) { return "Bejelentkezés biometrikus azonosítással"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1672029640 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó használata"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b746636643 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrikus azonosítás használata"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1630272394 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz frissítsd a jelszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1194921166 = messageFormatterFn((function(  ) {
  return function(d) { return "Csak akkor férhetsz hozzá a fiókodhoz, ha átállítod a jelszavadat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1154661608 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a605637352 = messageFormatterFn((function(  ) {
  return function(d) { return "Köszöntenek a tagoknak szóló extrák"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1381713394 = messageFormatterFn((function(  ) {
  return function(d) { return "Vágj bele a következő kalandodba – most $" + d["0"] + " értékű pontot adunk hozzá ajándékba!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a539791586 = messageFormatterFn((function(  ) {
  return function(d) { return "Azonnal megtekintheted őket a fiókodban és felhasználhatod őket az első foglalásodnál: egyszerűen keresd meg a pontok felhasználásának lehetőségét a fizetésnél."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a590984976 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostantól Expedia-tag vagy."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1563898912 = messageFormatterFn((function(  ) {
  return function(d) { return "Kezdj el spórolni azonnal a Tagoknak szóló árakkal, és szerezz pontokat a foglalásokkal."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a408552725 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelentkezz be vagy hozz létre egy fiókot"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1805345189 = messageFormatterFn((function(  ) {
  return function(d) { return "Tagként átlagosan " + d["0"] + "%-ot spórolhatsz hotelek ezrein – a tagság mindig ingyenes."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b441853443 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatással igazolod, hogy elolvastad és elfogadod az <a href=" + d["1"] + " " + d["3"] + ">Általános szerződési feltételeinket</a> és az <a href=" + d["2"] + " " + d["4"] + ">Adatvédelmi nyilatkozatunkat</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1439180411 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatással igazolod, hogy elolvastad és elfogadod az <a href=" + d["1"] + " " + d["5"] + ">Általános szerződési feltételeinket</a>, az <a href=" + d["2"] + " " + d["6"] + ">Adatvédelmi nyilatkozatunkat</a> és a(z) <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " Általános szerződési feltételeit</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1361981152 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatással igazolod, hogy elolvastad és elfogadod az <a href=" + d["1"] + " " + d["4"] + ">Általános szerződési feltételeinket</a>, az <a href=" + d["2"] + " " + d["5"] + ">Adatvédelmi nyilatkozatunkat</a> és a <a href=" + d["3"] + " " + d["6"] + ">One Key Általános szerződési feltételeit</a>."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2055973124 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail-cím"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2020656578 = messageFormatterFn((function(  ) {
  return function(d) { return "Érvényes e-mail-címet adj meg"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1031683393 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1847692110 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a695486184 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a798881215 = messageFormatterFn((function(  ) {
  return function(d) { return "Ezt csak személyes eszközökön használd. A fiókod biztonsága érdekében ne jelöld be, ha másokkal közösen használt eszközről jelentkezel be."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1174976462 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b526192298 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b521296964 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b534754808 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a798993861 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1311905344 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sokszor próbáltál meg bejelentkezni. Várnod kell " + d["0"] + " percet, mielőtt ismét próbálkozhatnál."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2121185233 = messageFormatterFn((function(  ) {
  return function(d) { return "Szerezz előnyöket egyetlen fiókkal az Expedia, a Hotels.com és a Vrbo rendszerében."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1347496151 = messageFormatterFn((function(  ) {
  return function(d) { return "Szerezz hozzáférést az utazás világához egyetlen fiókkal az Expedia, a Hotels.com és a Vrbo rendszerében."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1793256880 = messageFormatterFn((function(  ) {
  return function(d) { return "Böngéssz a szálláshelyek között, mentsd el őket, tervezz a csoportod számára, és férj hozzá a foglalásod részleteihez."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a620178863 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiókodat egy biztonsági rutinellenőrzés során szüneteltettük. Adataid biztonságban vannak, de a jelszavadat meg kell változtatni."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b537433375 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelentkezz be, és foglald le a szállásodat, hogy OneKeyCasht szerezhess"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b163707501 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretnénk megbizonyosodni a személyazonosságodról"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a326150247 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az e-mailben kapott biztonságos kódot. Ha nincs a beérkező leveleid között, nézd meg a spam- vagy levélszemétmappában."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1776093275 = messageFormatterFn((function(  ) {
  return function(d) { return "Erősítsük meg az e-mail-címedet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a655795477 = messageFormatterFn((function(  ) {
  return function(d) { return "A folytatáshoz add meg a(z) " + d["0"] + " címre kapott biztonsági kódot. Ha nincs a beérkező leveleid között, nézd meg a spam- vagy levélszemétmappában."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1375137327 = messageFormatterFn((function(  ) {
  return function(d) { return "6 számjegyű kód"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a849747153 = messageFormatterFn((function(  ) {
  return function(d) { return "Kód újraküldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b718184856 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + " múlva)"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b789673360 = messageFormatterFn((function(  ) {
  return function(d) { return "Kód újraküldése " + d["0"] + " s múlva"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a529906368 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem kaptad meg az e-mailt?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1400311266 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " másodperc múlva új kódot kérhetsz"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b231533621 = messageFormatterFn((function(  ) {
  return function(d) { return "Új biztonsági kód kérése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1577004693 = messageFormatterFn((function(  ) {
  return function(d) { return "Küldtünk egy 6 jegyű kódot az e-mail-címedre"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1216234336 = messageFormatterFn((function(  ) {
  return function(d) { return "Inkább megadom a jelszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1072509407 = messageFormatterFn((function(  ) {
  return function(d) { return "Érvénytelen a kód, próbálkozz újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2113959247 = messageFormatterFn((function(  ) {
  return function(d) { return "A kód lejárt, kérj újat, és próbálkozz újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b297174844 = messageFormatterFn((function(  ) {
  return function(d) { return "Ha nincs a beérkező leveleid között, nézd meg a spam- vagy levélszemétmappában"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b101907925 = messageFormatterFn((function(  ) {
  return function(d) { return "Frissítettük a rendszerünket, és most arra kérünk, hogy erősítsd meg az e-mail-címedet. Add meg az e-mailben kapott biztonságos kódot."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b835692300 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiba történt a rendszerünkben. Próbálkozz újra."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1652136381 = messageFormatterFn((function(  ) {
  return function(d) { return "A bejelentkezési módod frissítéséhez add meg az e-mailben kapott biztonságos kódot."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a965302697 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg a jelszót"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b425720094 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonságos kód küldése e-mailben"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b790359234 = messageFormatterFn((function(  ) {
  return function(d) { return "Az e-mail-cím és a jelszó nem egyezik"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1393827335 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1734674236 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó létrehozása | " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1365817905 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1109477129 = messageFormatterFn((function(  ) {
  return function(d) { return "Ugyanazzal az e-mail-címmel és jelszóval jelentkezhetsz be az Expedia, a Hotels.com és a Vrbo rendszerébe."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1451741833 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó létrehozása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1806982650 = messageFormatterFn((function(  ) {
  return function(d) { return "Állíts be egy jelszót, amelyet más biztonságos bejelentkezési módok mellett használhatsz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1609917893 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a551461512 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása | " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a984676709 = messageFormatterFn((function(  ) {
  return function(d) { return "Új jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1869329579 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostantól ugyanazzal a fiókkal jelentkezhetsz be az Expedia, a Hotels.com és a Vrbo rendszerébe. Állíts be egy új biztonságos jelszót az összevont fiókodhoz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b468109909 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó beállítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b63350435 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó módosítása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1947567578 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó módosítása | " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b926305933 = messageFormatterFn((function(  ) {
  return function(d) { return "Egyedi és erős jelszót használj."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b231755059 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelszó frissítése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a851769018 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem sikerült frissíteni a jelszavadat. Próbálkozz újra."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a530102104 = messageFormatterFn((function(  ) {
  return function(d) { return "Elfelejtett jelszó"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2069502846 = messageFormatterFn((function(  ) {
  return function(d) { return "Add meg az e-mail-címed, és küldünk egy biztonságos kódot a bejelentkezéshez."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1879667038 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail küldése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1978285910 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapcsolat"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b619318395 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1846382982 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b21512034 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, várj, amíg ellenőrizzük a fiókodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a370830049 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2074533307 = messageFormatterFn((function(  ) {
  return function(d) { return "Értem"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1181456735 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos csak az utazásod befejeződése után törölheted."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1056263104 = messageFormatterFn((function(  ) {
  return function(d) { return "A problémamentes utazás érdekében szükséged lesz a fiókra a foglalásod és az ügyfélszolgálat eléréséhez, ha az utolsó pillanatban még módosítani kellene valamit."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1792161453 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, de először törölnöd kell a tulajdonosi Vrbo-fiókodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a318606084 = messageFormatterFn((function(  ) {
  return function(d) { return "A folyamat elindításához nyisd meg a Súgót a webhelyen vagy az alkalmazásban, hogy közvetlenül felvehesd a kapcsolatot az ügyfélszolgálattal."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2145171148 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbálkozz újra az utazásod végét követően."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1059472209 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, mondd el, miért szünteted meg a fiókodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a12396062 = messageFormatterFn((function(  ) {
  return function(d) { return "Túl sok e-mailt vagy értesítést kapok"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b555065932 = messageFormatterFn((function(  ) {
  return function(d) { return "Van egy másik " + d["0"] + "-fiókom"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b538434833 = messageFormatterFn((function(  ) {
  return function(d) { return "Az utazásom véget ért, így már nincs szükségem a fiókra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2025613429 = messageFormatterFn((function(  ) {
  return function(d) { return "Rossz tapasztalatokat szereztem, amikor a(z) " + d["0"] + " rendszerében foglaltam"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a990623178 = messageFormatterFn((function(  ) {
  return function(d) { return "Egyéb"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a9386419 = messageFormatterFn((function(  ) {
  return function(d) { return "Kihagyás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1633887878 = messageFormatterFn((function(  ) {
  return function(d) { return "Küldés"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2117380234 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, hogy elmész. Néhány fontos tudnivaló:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1895954621 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " Expedia Rewards-pontot " + d["1"] + " értékben, " + d["2"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b221840882 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " Expedia Rewards-pontot " + d["1"] + " értékben, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1392519024 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni minden utazási adatot, kreditet és beállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1035278662 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: El fogsz veszíteni " + d["0"] + " bónuszéjszakát " + d["1"] + " értékben és " + d["2"] + " bélyeget, amelyek átlagos értéke " + d["3"] + "."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a755962967 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni minden kreditet, kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b848544769 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " CheapCash-pontot " + d["1"] + " értékben, " + d["2"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1079658542 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " CheapCash-pontot " + d["1"] + " értékben, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1793792713 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " Orbucks-pontot " + d["1"] + " értékben, " + d["2"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a335911834 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " Orbucks-pontot " + d["1"] + " értékben, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a391152003 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " MrJet Rewards-pontot " + d["1"] + " értékben, " + d["2"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b127035442 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " MrJet Rewards-pontot " + d["1"] + " értékben, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1203825823 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " BONUS+-pontot " + d["1"] + " értékben, " + d["2"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a965370674 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " BONUS+-pontot " + d["1"] + " értékben, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1043018967 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a305312766 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogsz veszíteni " + d["0"] + " értékű kreditet, valamint minden kupont, mentett utazási tételt és fiókbeállítást."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b741475464 = messageFormatterFn((function(  ) {
  return function(d) { return "Biztonságosan megőrizhetünk bizonyos információkat – például a tranzakciók rekordjait –, hogy teljesítsük törvényi kötelezettségeinket, illetve ahhoz, hogy jogi követeléseket tudjunk támasztani vagy érvényesíteni, valamint védekezni tudjunk ilyen követelések esetén. Az információkat biztonságosan tároljuk, és ha már nincs rájuk szükség, töröljük, anonimizáljuk vagy véglegesen olvashatatlanná tesszük."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1353715596 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók végleges törlése"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2111878724 = messageFormatterFn((function(  ) {
  return function(d) { return "Nem törlöm a fiókomat"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1062253618 = messageFormatterFn((function(  ) {
  return function(d) { return "Reméljük, még viszontlátunk!"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a353658451 = messageFormatterFn((function(  ) {
  return function(d) { return "A törlési kérelmed feldolgozása néhány hetet vesz igénybe, így amíg rendszerünk nem frissül, továbbra is kaphatsz tőlünk üzeneteket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a735500077 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbálkozz újra"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1498072468 = messageFormatterFn((function(  ) {
  return function(d) { return "Rendszerhiba történt.  Küldd be újra a fióktörlési kérést, vagy próbálkozz néhány perc múlva."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2112584156 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezárás"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a45812661 = messageFormatterFn((function(  ) {
  return function(d) { return "Milyen név szerepel az úti okmányodon?"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1987035397 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiókban azt a neved add meg, amit az utazáshoz használt személyazonosító okmányodon – például az útleveledben vagy a személyi igazolványodon – szerepel. A legközelebbi foglalásnál automatikusan betöltjük."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1708107497 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " által kínált akciók, ajánlatok és egyéb információk fogadása e-mailben."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a145112614 = messageFormatterFn((function(  ) {
  return function(d) { return "A(z) " + d["0"] + " által kínált akciók, ajánlatok és egyéb információk fogadása e-mailben. A marketinges e-mailekről bármikor leiratkozhatsz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1657390623 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók adatai"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a498786082 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiók adatai | " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1486570249 = messageFormatterFn((function(  ) {
  return function(d) { return "Szeretném megkapni a(z) " + d["0"] + " emailjeit az ajánlatokról, kedvezményekről és más információkról. Bármikor leiratkozhatsz."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b2102739211 = messageFormatterFn((function(  ) {
  return function(d) { return "Regisztráció | " + d["0"]; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a119208339 = messageFormatterFn((function(  ) {
  return function(d) { return "Maradj naprakész"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a930538611 = messageFormatterFn((function(  ) {
  return function(d) { return "Beleegyezés a marketininformációk küldésébe"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1323255678 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a634485280 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b112750568 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1777623872 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1553757826 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1578646489 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b912038651 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a490253362 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, de várnod kell addig, amíg be nem fejeződik az utazásod"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1967683294 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, de várnod kell addig, amíg be nem fejeződik a közelgő utazásod"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a667303708 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiókod használatával férhetsz hozzá a foglalásod részleteihez és szükség esetén a támogatáshoz. Próbálkozz újra az utazásod végét követően."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1156706616 = messageFormatterFn((function(  ) {
  return function(d) { return "A fiókod használatával férhetsz hozzá a foglalásod részleteihez és szükség esetén a támogatáshoz. Próbálkozz újra az utazásaid befejezése után."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b953832895 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnos a fiókodat jelenleg nem lehet törölni"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1641184213 = messageFormatterFn((function(  ) {
  return function(d) { return "Ezzel a fiókkal adsz ki szálláshelyeket a Vrbón. A fiók törlése előtt be kell jelentkezned a Vrbo-tulajdonosi applikációba vagy weboldalra, és el kell távolítanod az aktív hirdetéseket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a557095076 = messageFormatterFn((function(  ) {
  return function(d) { return "Kérjük, mondd el, hogy miért szünteted meg a fiókodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1257890617 = messageFormatterFn((function(  ) {
  return function(d) { return "Van egy másik fiókom egy másik e-mail-címmel"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a154882760 = messageFormatterFn((function(  ) {
  return function(d) { return "Rossz tapasztalataim voltak a foglalással"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b93950179 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, hogy elmész. Szeretnénk felhívni a figyelmedet arra, hogy a fiókod törlése végleges, és érinti az Expedia, a Hotels.com és a Vrbo rendszerében lévő adataidat is. Néhány fontos tudnivaló:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b375794136 = messageFormatterFn((function(  ) {
  return function(d) { return "Sajnáljuk, hogy elmész. Szeretnénk felhívni a figyelmedet arra, hogy a fiókod törlése végleges, és érinti az Expedia, a Wotif, a Hotels.com és a Vrbo rendszerében lévő adataidat is. Néhány fontos tudnivaló:"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1057553151 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen törlődni fognak a fiókelőzményeid, a beállításaid és a mentett tételeid az Expedia, a Hotels.com és a Vrbo rendszeréből."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1646817418 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen törlődni fognak a fiókelőzményeid, a beállításaid és a mentett tételeid az Expedia, a Wotif, a Hotels.com és a Vrbo rendszeréből."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1136028173 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni az általad gyűjtött összes OneKeyCasht – beleértve a függőben lévő OneKeyCash-jóváírásokat is –, akárcsak az általad elért One Key-szintet és az azzal járó extrákat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b257761943 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni a függőben lévő OneKeyCash-jóváírásaidat, akárcsak az általad elért One Key-szintet és az azzal járó extrákat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b234322270 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni  " + d["0"] + " értékű OneKeyCashedet és minden függőben lévő OneKeyCash-jóváírásodat, akárcsak az általad elért One Key-szintet és az azzal járó extrákat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1746828 = messageFormatterFn((function(  ) {
  return function(d) { return "A Hotels.com Rewards hitelkártyák tulajdonosai a törlés után nem kapnak jutalmat a kártyatranzakcióik után."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a2004123985 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni összes Expedia Rewards-pontodat, többek között az összes megerősített és függőben lévő Expedia Rewards-pontodat, Hotels.com Rewards-bélyegedet és -bónuszéjszakádat, valamint az általad elért hűségprogrambeli szintet is."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b967762489 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni összes függőben lévő Expedia Rewards-pontodat és Hotels.com Rewards-bélyegedet, illetve -bónuszéjszakádat, valamint az általad elért hűségprogrambeli szintet is."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1160713165 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni az összes Expedia-, Hotels.com- és Vrbo-kuponodat és -jóváírásodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b627034408 = messageFormatterFn((function(  ) {
  return function(d) { return "Véglegesen el fogod veszíteni az összes Expedia-, Wotif-, Hotels.com- és Vrbo-kuponodat és -jóváírásodat."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a814281254 = messageFormatterFn((function(  ) {
  return function(d) { return "Az Expedia-, Hotels.com- és Vrbo-fiókod törlésére vonatkozó kérelmed feldolgozása néhány hetet is igénybe vehet, így amíg rendszerünk nem frissül, továbbra is kaphatsz tőlünk üzeneteket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a715533937 = messageFormatterFn((function(  ) {
  return function(d) { return "Az Expedia-, Wotif-, Hotels.com- és Vrbo-fiókod törlésére vonatkozó kérelmed feldolgozása néhány hetet is igénybe vehet, így amíg rendszerünk nem frissül, továbbra is kaphatsz tőlünk üzeneteket."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b539488613 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key kártyádat a fiókod törlésekor lezárjuk, és a továbbiakban nem fogsz OneKeyCasht szerezni a vásárlásaiddal. A Wells Fargo fel fogja venni veled a kapcsolatot a kártyád lezárásával kapcsolatban."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a104949359 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key+ kártyádat a fiókod törlésekor lezárjuk, és a továbbiakban nem fogsz OneKeyCasht szerezni a vásárlásaiddal. A Wells Fargo fel fogja venni veled a kapcsolatot a kártyád lezárásával kapcsolatban."; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a528948252 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelentkezz be, vagy regisztrálj fiókot, hogy OneKeyCasht szerezhess utazásoddal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a831646526 = messageFormatterFn((function(  ) {
  return function(d) { return "Jelentkezz be, vagy regisztrálj fiókot, hogy jutalmakat szerezhess a tartózkodásoddal"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b553828709 = messageFormatterFn((function(  ) {
  return function(d) { return "Fizetés vendégként"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a1980928851 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-bejelentkezés: mobilszám hozzáadása"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a265870717 = messageFormatterFn((function(  ) {
  return function(d) { return "Hiba történt"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.b1988196951 = messageFormatterFn((function(  ) {
  return function(d) { return "Próbáljon meg újra bejelentkezni"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a958314656 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a589698841 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-embléma"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a580977836 = messageFormatterFn((function(  ) {
  return function(d) { return "Regisztráció"; }
})(), Globalize("hu-HU").pluralGenerator({}));
Globalize.a856014872 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b258531496 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1802632789 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1369880549 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b204390472 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a946037677 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1593331544 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b150249448 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a379244824 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b2044204181 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b922810440 = dateToPartsFormatterFn({"2":Globalize("hu-HU").numberFormatter({"raw":"00"}),"4":Globalize("hu-HU").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1200144711 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"V","mon":"H","tue":"K","wed":"Sz","thu":"Cs","fri":"P","sat":"Sz"}}}});
Globalize.b515505832 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"vasárnap","mon":"hétfő","tue":"kedd","wed":"szerda","thu":"csütörtök","fri":"péntek","sat":"szombat"}}}});
Globalize.b1768751272 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b128301944 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1548577589 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"}),"2":Globalize("hu-HU").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b120411626 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d.","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a542845747 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMMM d.","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.a1705370082 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMMM d.","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b83596034 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"január","2":"február","3":"március","4":"április","5":"május","6":"június","7":"július","8":"augusztus","9":"szeptember","10":"október","11":"november","12":"december"}}}});
Globalize.b82910841 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"y. MMM d.","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b484063402 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d., EEEE","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}},"days":{"E":{"4":{"sun":"vasárnap","mon":"hétfő","tue":"kedd","wed":"szerda","thu":"csütörtök","fri":"péntek","sat":"szombat"}}}});
Globalize.a535457579 = dateToPartsFormatterFn({"1":Globalize("hu-HU").numberFormatter({"raw":"0"})}, {"pattern":"MMM d., E","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"febr.","3":"márc.","4":"ápr.","5":"máj.","6":"jún.","7":"júl.","8":"aug.","9":"szept.","10":"okt.","11":"nov.","12":"dec."}}},"days":{"E":{"1":{"sun":"V","mon":"H","tue":"K","wed":"Sze","thu":"Cs","fri":"P","sat":"Szo"}}}});
Globalize.a1234728623 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a120182255 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a12284418 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1110169540 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a174323279 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1534012412 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1972045295 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a228464303 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a757958575 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b229286974 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b544096689 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1048971344 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1351666385 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1690055471 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a454981649 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"d"}));
Globalize.b1939984670 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a307446943 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a921559498 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a560594475 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a295117717 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a295802910 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1101793953 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a914171330 = dateFormatterFn(Globalize("hu-HU").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1446176930 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1734243998 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b777096591 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1899550549 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1788385022 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1971573875 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b708860258 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1842526046 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1922946978 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1018667983 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1069965054 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1439861183 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["wed",/^Sz/],["thu",/^Cs/],["sat",/^Sz/],["sun",/^V/],["mon",/^H/],["tue",/^K/],["fri",/^P/]]});
Globalize.a2031731998 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^csütörtök/],["sun",/^vasárnap/],["sat",/^szombat/],["wed",/^szerda/],["fri",/^péntek/],["mon",/^hétfő/],["tue",/^kedd/]]});
Globalize.a778486558 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.b1102805374 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1784381679 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1606439440 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d.","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]]});
Globalize.b1759346055 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM d.","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.b943099044 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMMM d.","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.a1909179460 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^szeptember/],["8",/^augusztus/],["11",/^november/],["12",/^december/],["2",/^február/],["3",/^március/],["4",/^április/],["10",/^október/],["1",/^január/],["6",/^június/],["7",/^július/],["5",/^május/]]});
Globalize.a1909864653 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"y. MMM d.","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]]});
Globalize.a1252713040 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d., EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]],"gregorian/days/format/wide":[["thu",/^csütörtök/],["sun",/^vasárnap/],["sat",/^szombat/],["wed",/^szerda/],["fri",/^péntek/],["mon",/^hétfő/],["tue",/^kedd/]]});
Globalize.b1766734223 = dateParserFn(Globalize("hu-HU").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMM d., E","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^szept\./],["2",/^febr\./],["3",/^márc\./],["1",/^jan\./],["4",/^ápr\./],["5",/^máj\./],["6",/^jún\./],["7",/^júl\./],["8",/^aug\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./]],"gregorian/days/format/abbreviated":[["wed",/^Sze/],["sat",/^Szo/],["thu",/^Cs/],["sun",/^V/],["mon",/^H/],["tue",/^K/],["fri",/^P/]]});
module.exports = Globalize;
